import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileDetailsToolConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsToolStack = createStackNavigator();

const NCFileDetailsToolNavigator = () => {
  return (
    <NCFileDetailsToolStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileDetailsToolConfig.map(({ Component, name }) => (
        <NCFileDetailsToolStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsToolStack.Navigator>
  );
};

export { NCFileDetailsToolNavigator };
